import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PageBaseComponent } from '../page-base/page-base.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-cardpage-base',
  standalone: true,
  imports: [
    CommonModule,
    ProgressSpinnerModule,
    PageBaseComponent,
    TranslatePipe
  ],
  templateUrl: './cardpage-base.component.html',
  styleUrls: ['./cardpage-base.component.css']
})
export class CardpageBaseComponent {
  @Input() loading = false; // Riceve lo stato dalla pagina figlia
}
